import history from './history'
import config from '../../proxyConfig/index'
import * as Sentry from '@sentry/react'
import { isProductionLikeEnvironment } from './runtime-environment'

const sentryInit = () => {
  if (!isProductionLikeEnvironment) {
    return null
  }

  if (Sentry) {
    const { VITE_REACT_APP_VERSION, VITE_TARGET_ENV, VITE_SENTRY_DSN } =
      import.meta.env

    const escapeRegExp = (string) => {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    }

    const release = `${VITE_REACT_APP_VERSION || '00'}${
      !!VITE_TARGET_ENV && VITE_TARGET_ENV !== 'production'
        ? VITE_TARGET_ENV.substring(0, 2)
        : ''
    }`

    const baseUrlRegexPattern = `^${escapeRegExp(config.url)}`

    const baseUrlRegex = new RegExp(baseUrlRegexPattern)

    Sentry.init({
      dsn: VITE_SENTRY_DSN,
      environment: VITE_TARGET_ENV,
      debug: VITE_TARGET_ENV !== 'production',
      release,
      attachStacktrace: true,
      replaysSessionSampleRate: 0.02,
      replaysOnErrorSampleRate: 0.5,
      tracesSampleRate: 0.01,
      tracePropagationTargets: ['localhost', baseUrlRegex],
      ignoreErrors: [
        'ResizeObserver loop limit exceeded',
        'ResizeObserver loop completed with undelivered notifications',
        'Non-Error promise rejection captured with value: null',
        'Non-Error promise rejection captured with value: undefined',
        // Microsoft Edge's built-in extensions (read aloud, spellcheck) message
        // a content script that isn't there - unrelated to our code. No
        // stacktrace ever accompanies it, so denyUrls below can't catch it.
        /Object Not Found Matching Id/
      ],
      denyUrls: [
        /^chrome-extension:\/\//i,
        /^moz-extension:\/\//i,
        /^safari-extension:\/\//i
      ],
      beforeSend(event, hint) {
        const error = hint?.originalException
        if (error?.name === 'CanceledError' || error?.code === 'ERR_CANCELED') {
          return null
        }
        const status = error?.response?.status ?? error?.status
        // Backend 5xx (including 502/503/511 from the gateway) are already
        // captured by the backend's Sentry, so don't report them from here.
        if (status === 401 || status === 403 || status >= 500) {
          return null
        }
        return event
      },
      integrations: [
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
          maskAllInputs: true,
          networkDetailAllowUrls: [
            'https://traefik.cloud.docu.solutions/',
            'https://api.docu-tools.com/'
          ],
          networkRequestHeaders: ['X-Custom-Header'],
          networkResponseHeaders: ['X-Custom-Header']
        }),
        Sentry.reactRouterV5BrowserTracingIntegration({ history })
      ]
    })
  }
}

export default sentryInit
